import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { MessageHandlerComponent } from '../Controls/MessageHandler.component';
import { BlockComponent } from '../Controls/Block.component';
import { RequestValidationMessagesComponent } from '../../components/Requests/RequestValidationMessages.component';
import { ContactEditComponent } from '../Editors/ContactEdit.component';


@Component({
    selector: 'my-contact-grid',
    templateUrl: './ContactGrid.component.html'
})
export class ContactGridComponent implements OnInit {
    
    public displayDialog: boolean;

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(ContactEditComponent) recordEditComponent: ContactEditComponent;
    @Output() public contactChanged: EventEmitter<ent.ContactInfo> = new EventEmitter();
    @Output() public contactDeleted: EventEmitter<ent.ContactInfo> = new EventEmitter();
    cols: any[] = [];
    records: ent.ContactInfo[] = [];

    @Input() public showUpdateNeeded: boolean;
    @Input() public showHeaderButtons: boolean;
    @Input() public showAddAndDeleteButtonColumn: boolean;
    @Input() public showAppliesToPayerCheckbox: boolean;
    @Input() public showContactPersonName: boolean;
    @Input() public showContactPhoneNumber: boolean;
    @Input() public showContactPhoneExtension: boolean;
    @Input() public showSecondaryContactName: boolean;
    @Input() public showSecondaryContactPhoneNumber: boolean;
    @Input() public showContactPartnerNumber: boolean;
    @Input() public showAlternateContactPhoneNumber: boolean;
    @Input() public showAlternateContactPhoneExtension: boolean;
    @Input() public showEmail: boolean;
    @Input() public showContactFaxNumber: boolean;
    @Input() public showContactDepartment: boolean;
    @Input() public showContactFunction: boolean;
    @Input() public showAppliesToCustomer: boolean;
    @Input() public showAppliesToPayer: boolean;
    @Input() public showBypassLastNameRequired: boolean;
    @Input() public showCopyOverallAccountPhoneNumber: boolean;
    @Input() public showCopyOverallAccountEmail: boolean;
    @Input() public showAppliesToField: boolean;

    @Input() public requireUpdateNeeded: boolean;
    @Input() public requireContactPersonName: boolean;
    @Input() public requireContactPersonLastName: boolean;
    @Input() public requireContactPhoneNumber: boolean;
    @Input() public requireContactPhoneExtension: boolean;
    @Input() public requireSecondaryContactName: boolean;
    @Input() public requireSecondaryContactPhoneNumber: boolean;
    @Input() public requireContactPartnerNumber: boolean;
    @Input() public requireAlternateContactPhoneNumber: boolean;
    @Input() public requireAlternateContactPhoneExtension: boolean;
    @Input() public requireEmail: boolean;
    @Input() public requireContactFaxNumber: boolean;
    @Input() public requireContactDepartment: boolean;
    @Input() public requireContactFunction: boolean;
    @Input() public setContactFunctionValueToDefault: boolean;

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService,
        private employeeService: serv.EmployeeService, private router: Router) {

    }

    ngOnInit(): void {

        //this.editedRecord = new ent.ContactInfo();
        if (!this.authenticationService.checkLoginStatus()) {
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
        this.loadColumns();
        this.recordEditComponent.contactDepartmentDropdownComponent.load();
        this.recordEditComponent.contactFunctionDropdownComponent.load();
        if (this.recordEditComponent){
            this.recordEditComponent.updateNeededDropdownComponent.load();
        }
        

    }


    loadColumns() {
        this.cols = [
            { field: 'ID', header: 'ID', width: '7em' },
           
        ];

        if(this.showAppliesToField){
            this.cols.push({ field: 'AppliesToDisplayValue', header: 'Applies To', width: '7em' });
        }

        if (this.showUpdateNeeded){
            this.cols.push({ field: 'UpdateNeeded.FullName', header: 'Update Needed' });
        }

        if (this.showContactPersonName){
            this.cols.push({ field: 'FirstName', header: 'First Name' });
            this.cols.push({ field: 'LastName', header: 'Last Name' });
        }

        if (this.showContactPhoneNumber){
            this.cols.push({ field: 'ContactPhoneNumber', header: 'Contact Phone #' });
        }

        if (this.showContactPhoneExtension){
            this.cols.push({ field: 'ContactPhoneExtension', header: 'Contact Phone Ext' });
        }

        if (this.showEmail){
            this.cols.push({ field: 'Email', header: 'Email' });
        }

        if (this.showSecondaryContactName){
            this.cols.push({ field: 'SecondaryContactName', header: 'Secondary Contact Name' });
        }

        if (this.showSecondaryContactPhoneNumber){
            this.cols.push({ field: 'SecondaryContactPhoneNumber', header: 'Secondary Contact Phone #' });
        }

        if (this.showContactPartnerNumber){
            this.cols.push({ field: 'ContactPartnerNumber', header: 'Contact Partner Number' });
        }

        if (this.showAlternateContactPhoneNumber){
            this.cols.push({ field: 'AlternateContactPhoneNumber', header: 'Contact Phone # (ALT)' });
        }

        if (this.showAlternateContactPhoneExtension){
            this.cols.push({ field: 'AlternateContactPhoneExtension', header: 'Contact Phone Ext (ALT)' });
        }

        if (this.showContactFaxNumber){
            this.cols.push({ field: 'ContactFaxNumber', header: 'Contact Fax #' });
        }

        if (this.showContactDepartment){
            this.cols.push({ field: 'ContactDepartment.Name', header: 'Contact Department' });
        }

        if (this.showContactFunction){
            this.cols.push({ field: 'ContactFunction.Name', header: 'Contact Function' });
        }

    }

    onAddClick(event: any) {
        this.recordEditComponent.contactInfo.CopyOverallAccountPhoneNumber = false;
        this.recordEditComponent.contactInfo.CopyOverallAccountEmail = false;
        this.recordEditComponent.contactInfo = new ent.ContactInfo();
        this.recordEditComponent.contactInfo.ContactDepartment = {ID: Constants._NONE, Code: "", Name: ""};
        this.recordEditComponent.contactInfo.ContactFunction = {ID: Constants._NONE, Code: "", Name: ""};
        this.recordEditComponent.contactInfo.UpdateNeeded = {ID: Constants._NONE, Code: "", Name: ""};
        this.recordEditComponent.contactDepartmentDropdownComponent.value = Constants._NONE;
        if (this.setContactFunctionValueToDefault) {
            this.recordEditComponent.contactFunctionDropdownComponent.value = Constants._DEFAULT_CONTACT_FUNCTION_ID;    
            this.recordEditComponent.contactFunctionChange(Constants._DEFAULT_CONTACT_FUNCTION_ID);
        }
        else {
            this.recordEditComponent.contactFunctionDropdownComponent.value = Constants._NONE;
        }
        
        this.recordEditComponent.updateNeededDropdownComponent.value = Constants._NONE;
        this.records = [...this.records, this.recordEditComponent.contactInfo];
        this.displayDialog = true;
        if(this.recordEditComponent.hostedBy == Constants._HOSTED_BY_BILLING_ADDRESS){
            this.recordEditComponent.contactInfo.AppliesToPayer = true;
            this.recordEditComponent.contactInfo.AppliesToCustomer = false;
        } 
        if(this.recordEditComponent.hostedBy == Constants._HOSTED_BY_CONTACT_DETAILS){
            this.recordEditComponent.contactInfo.AppliesToCustomer = true;
            this.recordEditComponent.contactInfo.AppliesToPayer = false;
        }
    }

    onEditClick(event: any, record: ent.ContactInfo) {
        this.recordEditComponent.contactInfo.CopyOverallAccountPhoneNumber = false;
        this.recordEditComponent.contactInfo.CopyOverallAccountEmail = false;
        this.recordEditComponent.contactInfo = record;
        this.recordEditComponent.contactDepartmentDropdownComponent.value = record.ContactDepartmentID;
        this.recordEditComponent.contactFunctionDropdownComponent.value = record.ContactFunctionID;
        this.recordEditComponent.updateNeededDropdownComponent.value = record.UpdateNeededID;
        if(this.showUpdateNeeded){
            this.recordEditComponent.setContactPartnerValidators(record.UpdateNeededID);
        }
        this.displayDialog = true;

    }

    onDeleteClick(event: any, lineItem: ent.ContactInfo){
        this.records = _.remove(this.records, x=>x !== lineItem);
        this.contactDeleted.emit(lineItem);
    }

    onRecordEditOK() {
        this.displayDialog = false;
        this.contactChanged.emit(this.recordEditComponent.contactInfo);
    }


    getCellData(row: any, col: any): any {
        const nestedProperties: string[] = col.field.split('.');
        let value: any = row;
        for (const prop of nestedProperties) {
            value = value[prop];
        }

        return value;
    }

    getColumnWidth(col: any) {
        if (!col['width']) {
            return '15em'
        }
        else {
            return col['width'];
        }

    }
}
